module.exports = __webpack_public_path__ + "static/worksafe-stf-logo-ddc571df3b90467e697726bd6e88902f.png";